import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Mail } from "lucide-react";

const STATUSES = [
  { v: "new", l: "Nuova" },
  { v: "in_progress", l: "In lavorazione" },
  { v: "closed", l: "Chiusa" },
];

export default function AdminRequests() {
  const [rows, setRows] = useState([]);
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/admin/requests").then((r) => setRows(r.data));
  useEffect(() => { load(); }, []);

  const changeStatus = async (id, status) => {
    try {
      await api.patch(`/admin/requests/${id}`, { status });
      await load();
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Errore");
    }
  };

  const remove = async (id) => {
    if (!window.confirm("Eliminare questa richiesta?")) return;
    try {
      await api.delete(`/admin/requests/${id}`);
      await load();
    } catch (e) {
      toast.error(formatApiError(e?.response?.data?.detail) || "Errore");
    }
  };

  const filtered = filter === "all" ? rows : rows.filter((r) => r.status === filter);

  return (
    <div>
      <span className="label-eyebrow text-gray-500">Richieste dal sito</span>
      <h1 className="font-display uppercase text-4xl mt-1">Inbox</h1>

      <div className="mt-6 flex gap-2 flex-wrap">
        {[{ v: "all", l: "Tutte" }, ...STATUSES].map((s) => (
          <button
            key={s.v}
            onClick={() => setFilter(s.v)}
            className={`label-eyebrow px-4 py-2 border ${filter === s.v ? "bg-gray-900 text-white border-gray-900" : "border-gray-300"}`}
            data-testid={`req-filter-${s.v}`}
          >
            {s.l}
          </button>
        ))}
      </div>

      <div className="mt-8 space-y-4">
        {filtered.length === 0 && <div className="text-gray-500">Nessuna richiesta.</div>}
        {filtered.map((r) => (
          <div key={r.id} className="card-flat p-5" data-testid={`req-${r.id}`}>
            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 flex-wrap">
                  <span className="label-eyebrow text-gray-500">{new Date(r.created_at).toLocaleString("it-IT")}</span>
                  <span className="label-eyebrow text-[color:var(--nsa-orange)]">Sezione: {r.section}</span>
                  <span className={`text-xs px-2 py-1 ${r.status === "new" ? "bg-orange-100 text-orange-700" : r.status === "closed" ? "bg-gray-100 text-gray-600" : "bg-blue-100 text-blue-700"}`}>{STATUSES.find((s) => s.v === r.status)?.l || r.status}</span>
                </div>
                <div className="font-display uppercase text-xl mt-2">{r.subject}</div>
                <div className="text-sm text-gray-500 mt-1">
                  <span className="font-medium text-gray-900">{r.name}</span> — {r.email} {r.phone && `· ${r.phone}`}
                </div>
                <div className="mt-3 text-gray-700 whitespace-pre-wrap">{r.message}</div>
              </div>
              <div className="flex flex-col gap-2 md:w-52">
                <select
                  value={r.status}
                  onChange={(e) => changeStatus(r.id, e.target.value)}
                  className="border border-gray-300 px-3 py-2 label-eyebrow"
                  data-testid={`req-status-${r.id}`}
                >
                  {STATUSES.map((s) => <option key={s.v} value={s.v}>{s.l}</option>)}
                </select>
                <a
                  href={`mailto:${r.email}?subject=Re: ${encodeURIComponent(r.subject)}`}
                  className="border border-gray-300 px-3 py-2 label-eyebrow inline-flex items-center justify-center gap-2 hover:border-gray-900"
                >
                  <Mail size={14} /> Rispondi
                </a>
                <button
                  onClick={() => remove(r.id)}
                  className="border border-gray-300 px-3 py-2 label-eyebrow inline-flex items-center justify-center gap-2 hover:border-red-600 hover:text-red-600"
                  data-testid={`req-del-${r.id}`}
                >
                  <Trash2 size={14} /> Elimina
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
